var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-a43571e2": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.825 7.8125V5.075C13.825 4.06055 13.4221 3.08764 12.7047 2.37032C11.9874 1.65299 11.0145 1.25 10 1.25V1.25C8.9856 1.25 8.01269 1.65299 7.29537 2.37032C6.57804 3.08764 6.17505 4.06055 6.17505 5.075V7.8125M9.45005 14.375H10.55M16.0125 10V16.5625C16.0125 17.1427 15.7821 17.6991 15.3718 18.1093C14.9616 18.5195 14.4052 18.75 13.825 18.75H6.17505C5.59489 18.75 5.03849 18.5195 4.62825 18.1093C4.21802 17.6991 3.98755 17.1427 3.98755 16.5625V10C3.98755 9.41984 4.21802 8.86344 4.62825 8.4532C5.03849 8.04297 5.59489 7.8125 6.17505 7.8125H13.825C14.4052 7.8125 14.9616 8.04297 15.3718 8.4532C15.7821 8.86344 16.0125 9.41984 16.0125 10V10Z",
    stroke: "#a5a3b5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic_clock.b6814064a16bfd23129b8ab8585d4436.svg";
export { ForwardRef as ReactComponent };